import { IDeletePatrimonioCentroCustoUseCase } from "../../../presentation/useCases/delete/delete_patrimonio_centro_custo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeletePatrimonioCentroCustoUseCase
 */

export class DeletePatrimonioCentroCustoUseCase implements IDeletePatrimonioCentroCustoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deletePatrimonioCentroCusto(idPatrimonioCentroCusto: number): Promise<void> {
    await this.repository.deletePatrimonioCentroCusto(idPatrimonioCentroCusto);
  }
}
